export const getTravelers = (props) => props?.travelers ?? [];
